window.createProductCustomiser = function(product_id,product_handle,html_id){
    var ProductCustomiser = {
        canvas: {
            get: null,
            context: null,
            width: null,
            height: null,
            auto_curve: false,
            mask_color: null,
            mask_calculated: null,
            auto_curve_interrupt: 0
        },
        positions: {
            name_x: null,
            name_y: null,
            icon_x: null,
            icon_y: null,
            number_x: null,
            number_y: null,
            max_arc: 359,
          	max_width: 200,
            icon_height: 0,
            icon_width: 0,
        },
        customisation: {
            name: '',
            number: '',
            activeBadges: [],
            badgeNames: [],
            curved: false,
            template_name: null,
            template_number: null,
            hero_or_custom: 'custom'
        },
        font_name: null,
        font_number: null,
        outline_name: null,
        outline_number: null,
        defaultImage: null,
        construct: function(product_id,product_handle,html_id){
            $.ajax('/products/'+product_handle+'?view=customiser')
            .done(function(response){
                if(response.trim() !== ''){
                  	response = response.replaceAll('@htmlid',html_id).replace('<div id="shopify-section-customisation-inhouse" class="shopify-section">','').slice(0, -6)
                    $('.customisers-inhouse').append(response)
                    this.canvas.get = $('.customisers-inhouse').find('.preview-'+html_id)
                    if(this.canvas.get !== null){
                        this.defaultImage = new Image();
                        this.defaultImage.setAttribute('crossOrigin','anonymous');
                        this.defaultImage.src = this.canvas.get.attr('data-initial');
                        this.badgesObject = JSON.parse($('.customisers-inhouse').attr('data-badges'));
                        this.defaultImage.addEventListener('load', function(){
                            //canvas set up
                            this.canvas.width = this.defaultImage.naturalWidth
                            this.canvas.height = this.defaultImage.naturalHeight
                            this.canvas.get.attr('width',this.canvas.width)
                            this.canvas.get.attr('height',this.canvas.height)
                            this.canvas.context = this.canvas.get[0].getContext("2d")
                            this.canvas.context.imageSmoothingEnabled = true
                            this.canvas.context.imageSmoothingQuality = 'high';

                            //coordinate setup
                            this.positions.name_x = parseInt(this.canvas.get.attr('data-center-name').split(',')[0])
                            this.positions.name_y = parseInt(this.canvas.get.attr('data-center-name').split(',')[1])
                            this.positions.number_x = parseInt(this.canvas.get.attr('data-center-number').split(',')[0])
                            this.positions.number_y = parseInt(this.canvas.get.attr('data-center-number').split(',')[1])

                            this.positions.icon_x = []
                            this.positions.icon_y = []
                            this.positions.icon_width = []
                            this.positions.icon_height = []

                            !!this.badgesObject && $(this.badgesObject.badges).each((index, badge) => {
                                if(badge.available != 'true'){
                                    this.badgesObject.badges.splice(index, 1)
                                }
                            });

                            !!this.badgesObject && $(this.badgesObject.badges).each((index, badge) => {
                                this.positions.icon_x[index] = parseInt(badge.position.split(',')[0])
                                this.positions.icon_y[index] = parseInt(badge.position.split(',')[1])
                                this.positions.icon_width[index] = parseInt(badge.dimensions.split(',')[0])
                                this.positions.icon_height[index] = parseInt(badge.dimensions.split(',')[1])
                            });
                            
                       		this.canvas.mask_color = this.hexToRgb(this.canvas.get.attr('data-mask-color'))
                       
                            this.positions.max_arc = parseInt(this.canvas.get.attr('data-max-arc'))
                            if(this.positions.max_arc > 359){
                                while(this.positions.max_arc > 359){
                                    this.positions.max_arc-=360
                                }
                            }
                          
                          	this.positions.max_width = parseInt(this.canvas.get.attr('data-max-width'))
                            this.canvas.auto_curve = this.canvas.get.attr('data-auto-curve') === 'true' ? true : false

                            this.customisation.curved = this.canvas.get.attr('data-curved') === 'true' ? true : false
                       		this.customisation.template_name = this.canvas.get.attr('data-template-name')
                            this.customisation.template_number = this.canvas.get.attr('data-template-number')

                            //colours
                            var color_name = null
                            var color_outline_name = null
                            var color_number = null
                            var color_outline_number = null
                       		if(this.canvas.get.attr('data-color-name').includes(',')){
                       			color_name = this.canvas.get.attr('data-color-name').split(',')[0]
                       			color_outline_name = this.canvas.get.attr('data-color-name').split(',')[1]
                       		}
                       		else{
                       			color_name = this.canvas.get.attr('data-color-name')
                       		}
                       		if(this.canvas.get.attr('data-color-number').includes(',')){
                            	color_number = this.canvas.get.attr('data-color-number').split(',')[0]
                       			color_outline_number = this.canvas.get.attr('data-color-number').split(',')[1]
                       		}
                       		else{
                       			color_number = this.canvas.get.attr('data-color-number')
                       		}
                       
                       		//fonts
                            var calculated_font_size = (parseFloat(this.canvas.width)/500.0)*parseFloat(this.canvas.get.attr('data-size-name'))
                            var font_value = this.canvas.get.attr('data-font-name')
                            if(font_value.includes(',')){
                                this.font_name = window.createTTFFont(font_value.split(',')[0].split('|')[0],font_value.split(',')[0].split('|')[1],calculated_font_size,color_name,this.canvas.context)
                                this.outline_name = window.createTTFFont(font_value.split(',')[1].split('|')[0],font_value.split(',')[1].split('|')[1],calculated_font_size,color_outline_name,this.canvas.context)
                            }
                            else{
                                this.font_name = window.createTTFFont(font_value.split('|')[0],font_value.split('|')[1],calculated_font_size,color_name,this.canvas.context)
                            }

                            var calculated_font_size = (parseFloat(this.canvas.width)/500.0)*parseFloat(this.canvas.get.attr('data-size-number'))
                            var font_value = this.canvas.get.attr('data-font-number')
                            if(font_value.includes(',')){
                                this.font_number = window.createTTFFont(font_value.split(',')[0].split('|')[0],font_value.split(',')[0].split('|')[1],calculated_font_size,color_number,this.canvas.context)
                                this.outline_number = window.createTTFFont(font_value.split(',')[1].split('|')[0],font_value.split(',')[1].split('|')[1],calculated_font_size,color_outline_number,this.canvas.context)
                            }
                            else{
                                this.font_number = window.createTTFFont(font_value.split('|')[0],font_value.split('|')[1],calculated_font_size,color_number,this.canvas.context)
                            }

                            //boot finish
                            this.render()
                            console.log("Init customiser: "+html_id)
                            $("body").trigger( "customiser_init", [html_id]);
                        }.bind(this))
                    }
                    else{
                        console.log("No canvas Found")
                    }
                }
                else{
                    console.log("No Customiser Image Set")
                }
            }.bind(this))
            return this
        },
        drawBadge: function(image, icon_x, icon_y, icon_width, icon_height){
            this.canvas.context.drawImage(image, icon_x-(icon_width/2), icon_y-(icon_height/2), icon_width, icon_height)
        },
		applyMask: function(){
        	if(this.canvas.mask_calculated === null){
              this.canvas.mask_calculated = document.createElement('canvas');
              this.canvas.mask_calculated.width = this.defaultImage.naturalWidth
              this.canvas.mask_calculated.height = this.defaultImage.naturalHeight
              var ctx = this.canvas.mask_calculated.getContext("2d")
              ctx.drawImage(this.defaultImage, 0, 0)
              var imgData = ctx.getImageData(0, 0, this.canvas.width, this.canvas.height)
              var rowWidth = this.defaultImage.naturalWidth*4
              var colorOffset = 10
              for (var row = 0; row < imgData.data.length;row += rowWidth){
                  var mask_start = row+rowWidth-4
                  var mask_end = row
                  for (var i = row; i < row+rowWidth; i += 4) {
                    if (
                        this.canvas.mask_color.r < imgData.data[i]-colorOffset || this.canvas.mask_color.r > imgData.data[i]+colorOffset ||
                        this.canvas.mask_color.g < imgData.data[i+1]-colorOffset || this.canvas.mask_color.g > imgData.data[i+1]+colorOffset ||
                        this.canvas.mask_color.b < imgData.data[i+2]-colorOffset || this.canvas.mask_color.b > imgData.data[i+2]+colorOffset
                    ){
                        mask_start = i
                        break;
                    }
                  }
                  for (var i = row+rowWidth-4; i >= row; i -= 4) {
                    if (
                        this.canvas.mask_color.r < imgData.data[i]-colorOffset || this.canvas.mask_color.r > imgData.data[i]+colorOffset ||
                        this.canvas.mask_color.g < imgData.data[i+1]-colorOffset || this.canvas.mask_color.g > imgData.data[i+1]+colorOffset ||
                        this.canvas.mask_color.b < imgData.data[i+2]-colorOffset || this.canvas.mask_color.b > imgData.data[i+2]+colorOffset
                    ){
                        mask_end = i
                        break;
                    }
                  }
                  for (var i = row; i < row+rowWidth; i += 4) {
                    if (mask_start <= i && mask_end >= i){
                      imgData.data[i+0] = 0
                      imgData.data[i+1] = 0
                      imgData.data[i+2] = 0
                      imgData.data[i+3] = 0
                    }
                  }
              }
              ctx.putImageData(imgData, 0, 0);
			}
			this.canvas.context.drawImage(this.canvas.mask_calculated, 0, 0, this.canvas.width, this.canvas.height)
		},
        hexToRgb: function(hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
            } : null;
        },
        setName: function(text){
          	var banned = ['YXJzZQ==','YXJzZWhvbGU=','YXMgdXNlZnVsIGFzIHRpdHMgb24gYSBidWxs','YmFsbHM=','YmFzdGFyZA==','YmVhdmVy','YmVlZiBjdXJ0YWlucw==','YmVsbGVuZA==','YmVudA==','YmVyaw==','YmludA==','Yml0Y2g=','YmxpZ2h0ZXI=','YmxpbWV5','YmxpbWV5IG8ncmVpbGx5','Ymxvb2RjbGFhdA==','Ymxvb2R5','Ymxvb2R5IGhlbGw=','Ymxvb21pbmc=','Ym9sbG9ja3M=','Ym9uaw==','YnVnZ2Vy','YnVnZ2VyIG1l','YnVnZ2VyIG9mZg==','YnVpbHQgbGlrZSBhIGJyaWNrIHNoaXQtaG91c2U=','YnVra2FrZQ==','YnVsbHNoaXQ=','Y2Fjaw==','Y2Fk','Y2hhdg==','Y2hlZXNlIGVhdGluZyBzdXJyZW5kZXIgbW9ua2V5','Y2hvYWQ=','Y2h1ZmZlcg==','Y2x1bmdl','Y29iYmxlcnM=','Y29jaw==','Y29jayBjaGVlc2U=','Y29jayBqb2NrZXk=','Y29jay11cA==','Y29ja3N1Y2tlcg==','Y29ja3dvbWJsZQ==','Y29kZ2Vy','Y29yIGJsaW1leQ==','Y29yZXk=','Y293','Y3JhcA==','Y3Jpa2V5','Y3VudA==','ZGFmdA==','ZGFmdCBjb3c=','ZGFtbg==','ZGljaw==','ZGlja2hlYWQ=','ZGlkIGhlIGJvbGxvY2tzIQ==','ZGlkIGkgZnVjayBhcyBsaWtlIQ==','ZGlsZG8=','ZG9kZ3k=','ZHVmZmVy','ZmFubnk=','ZmVjaw==','ZmxhcHM=','ZnVjaw==','ZnVjayBtZSBzaWRld2F5cyE=','ZnVja2luZyBjdW50','ZnVja3RhcmQ=','Z2FzaA==','Z2luZ2Vy','Z2l0','Z29iIHNoaXRl','Z29kZGFt','Z29yYmxpbWV5','Z29yZG9uIGJlbm5ldHQ=','Z29ybWxlc3M=','aGXigJlzIGEga25vYg==','aGVsbA==','aG9ia25vY2tlcg==','aSdkIHJhdGhlciBzbm9ydCBteSBvd24gY3Vt','amVzdXMgY2hyaXN0','aml6eg==','a25vYg==','a25vYmJlcg==','a25vYmVuZA==','a25vYmhlYWQ=','bGlnZ2Vy','bGlrZSBmdWNraW5nIGEgZHlpbmcgbWFuJ3MgaGFuZHNoYWtl','bWFkIGFzIGEgaGF0dGVy','bWFua3k=','bWluZ2U=','bWluZ2Vy','bWluZ2luZw==','bW90aGVyZnVja2Vy','bXVudGVy','bXVwcGV0','bmFmZg==','bml0d2l0','bm9uY2U=','bnVtcHR5','bnV0dGVy','b2ZmIHRoZWlyIHJvY2tlcg==','cGlsbG9jaw==','cGlzaA==','cGlzcyBvZmY=','cGlzcy1mbGFwcw==','cGlzc2Vk','cGlzc2VkIG9mZg==','cGxheSB0aGUgZml2ZS1maW5nZXJlZCBmbHV0ZQ==','cGxvbmtlcg==','cG9uY2U=','cG9vZg==','cG91Zg==','cG94eQ==','cHJhdA==','cHJpY2s=','cHJpY2s=','cHJpY2t0ZWFzZXI=','cHVuYW5p','cHVubnk=','cHVzc3k=','cmFuZHk=','cmFwZXk=','cmF0IGFyc2Vk','cm90dGVy','cnViYmlzaA==','c2NydWJiZXI=','c2hhZw==','c2hpdA==','c2hpdGU=','c2hpdGZhY2Vk','c2thbms=','c2xhZw==','c2xhcHBlcg==','c2x1dA==','c25hdGNo','c29k','c29kLW9mZg==','c29uIG9mIGEgYml0Y2g=','c3B1bms=','c3RpY2sgaXQgdXAgeW91ciBhcnNlIQ==','c3dpbmU=','dGFraW5nIHRoZSBwaXNz','dGFydA==','dGl0cw==','dG9mZg==','dG9zc2Vy','dHJvbGxvcA==','dHVzcw==','dHdhdA==','dHdvbms=','dSBmdWtpbiB3YW5rZXI=','d2FsbHk=','d2Fua2Vy','d2Fua3N0YWlu','d2F6emFjaw==','d2hvcmU=','Y2VsdGlj','Y2F0aG9saWM=','cG9wZQ==','cHJvdGVzdGFudA==','IHZhdGljYW4=','IHN1bmRlcmxhbmQ=','IG1hY2tlbQ==','IGRpcnR5','IHdpZmUgYmVhdGVy','IG5pZ2dlcg==','IG5pZ2dh','bWNsYXJlbg==','YXN0b24gbWFydGlu','YXN0ZW4gbWFydGVu','YXN0YW4gbWFydGlu','ZmVycmFyaQ==','ZmVyYXJp','ZmVyYXJyaQ==','c2F1YmVy','a2ljayBzYXViZXI=','bWVyY2VkZXM=','cmVkIGJ1bGw=','cmJy','cmVkIGJ1bGwgcmFjaW5n','ai4gc2F2aWxl','IGogc2F2aWxlamV3','Zy5nbGl0dGVy','aGl0bGVy','a2tr','ZmFjaXN0','d2hpdGVwb3dlcg==','bmlnZ2Vy','bmlnZ2E=','cGFlZG8=','c2V4aXN0','c3Bhc3RpYw==','c3Bhc3RpY2s=','c3Bheg==','c3Bhenp5','eHh4','dmFn','Y3JpcHBsZQ==','dGl0','Ym9vYg==','Ym9vYmllcw==','dGVhYmFn','dGVhYmFnZ2Vy','cmFwZQ==','cmFwaXN0','cmFwZXI=','cG9ybg==','cG9ybmxvdmVy','YmRzbQ==','Y29jYWlu','d2VlZA==','bWV0aA==','aGVyaW9u','a2lsbA==','bXVyZGVy','a2lsbCBtZQ==','dGVycm9yaXN0','aXNpcw==','bWlsZg==','ZGlsZg==','b3JneQ==','Z2F5IGxvdmVy','cGVuaXM=','YW5hbA==','bmlwcGxl','ZGlsZG8=','ZWphY2x1YXRpb24=','aSBoYXRl','ZGVhdGggdG8=','dHJ1bXA=','YmFsbGJhZw==','dGVhYmFn','YXNzIGhvbGU=','YXNzIG11bmNo','YXNzd2hpcGU=','IGFzcyB3aGlwZQ==','IGFzc2hvbGU=','IGFzc211bmNo',]
            var filtered = text.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ-.\s]+/g,'')
            if(banned.findIndex(word => { return filtered.toLowerCase().includes(window.atob(word)) }) === -1){
                this.customisation.name = filtered.toUpperCase()
            }
            else{
                this.customisation.name = ''
            }
            var result = this.font_name.autoCurveTest(this.customisation.name,this.positions.max_width,this.customisation.curved,this.canvas.auto_curve)
            this.customisation.name = result[0]
            this.canvas.auto_curve_interrupt = result[1]
            this.render()
        },
        setHeroOrCustom: function(text){
          this.customisation.hero_or_custom = text
        },
        setBadge: function(img_src,name,id,price,varId){
          let badge_image = new Image()
          badge_image.setAttribute('crossOrigin','anonymous')
          badge_image.src = img_src
          let badgeObject = {
            image: badge_image,
            name: name,
            uniqueId: id.trim(),
            price: price,
            id: varId
          }
          this.customisation.activeBadges.push(badgeObject);
          this.customisation.badgeNames.push(name);
          badge_image.addEventListener('load', function(){
          	this.render()
          }.bind(this))
        },
        setNumber: function(text){
            if (text !== undefined) {
                if(text.length > 2){
                    while(text.length > 2){
                        text = text.slice(1)
                    }
                }
                this.customisation.number = text.trim().replace(/[^0-9]+/g,'')
                if(this.customisation.number !== ''){
                this.customisation.number = ''+Math.abs(parseInt(this.customisation.number))
                }
            }
            this.render()
        },
        reset: function(){
            this.customisation.name = ''
            this.customisation.number = ''
            this.customisation.activeBadges = []
            this.customisation.badgeNames = []
            this.render()
        },
        resetBadge: function(id){
            if(id != null && this.customisation.activeBadges.length > 1){
                $(this.customisation.activeBadges).each((index, activeBadge) => {
                    if(activeBadge.uniqueId == id){
                        this.customisation.activeBadges.splice(index, 1)
                        this.customisation.badgeNames.splice(index, 1)
                        this.render()
                        return;
                    }
                });
            } else {
                this.customisation.activeBadges = []
                this.customisation.badgeNames = []
                this.render()
            }
        },
        toggleCurve: function(){
            this.customisation.curved = !this.customisation.curved
            this.render()
        },
        getCartDetails: function(){
          	var exportImage = document.createElement('canvas')
            var ctx = exportImage.getContext("2d")
            exportImage.height = 150
            exportImage.width = this.canvas.width*(150/this.canvas.height)
            ctx.drawImage(this.canvas.get[0],0,0,exportImage.width-1,exportImage.height-1)
          	var exportVar = {
              main:{
                _name: this.customisation.name,_number: this.customisation.number,_badge_name: this.customisation.badgeNames.toString(),
                _template_name: this.customisation.template_name,
                _template_number: this.customisation.template_number,
                _hero_or_custom: this.customisation.hero_or_custom
              },
              img: exportImage.toDataURL(),
            }
            return exportVar
        },
        render: function(){
            this.canvas.context.drawImage(this.defaultImage, 0, 0)
            if(this.customisation.badge_image !== null){
                if(this.customisation.activeBadges.length > 0){
                    let badgesPrice = 0;
                    $(this.customisation.activeBadges).each((index, activeBadge) => {
                        $(this.badgesObject?.badges).each((index, badge) => {
                            if(badge.uniqueId.trim() == activeBadge.uniqueId){
                                let posX = this.positions.icon_x[index],
                                posY = this.positions.icon_y[index],
                                posW = this.positions.icon_width[index],
                                posH = this.positions.icon_height[index];
    
                                this.drawBadge(activeBadge.image, posX, posY, posW, posH);
                                return;
                            }
                        });
                        badgesPrice += parseInt(activeBadge.price)
                    });

                    if(badgesPrice.toString().length == 3){
                        $('.customisation-'+html_id+'').attr('data-variant-badge-price', `0${badgesPrice}`)
                    } else {
                        $('.customisation-'+html_id+'').attr('data-variant-badge-price', badgesPrice)
                    }
                }
            }
            if(this.font_name !== null && this.customisation.name !== ''){
                if(this.customisation.curved == true || this.canvas.auto_curve_interrupt == 1){
                    var measurement_name = this.font_name.measureText(this.customisation.name)
                    var measurement_number = this.font_number.measureText('00')
                    this.customisation.name = this.font_name.drawTextCurved(
                        this.customisation.name,
                        this.positions.number_x,
                        this.positions.number_y-(measurement_number.actualBoundingBoxAscent/2),
                        this.positions.number_y-this.positions.name_y-(measurement_name.actualBoundingBoxAscent/2),
                        this.positions.max_arc
                    )
                    if(this.outline_name != null){
                        this.outline_name.drawTextCurved(
                            this.customisation.name,
                            this.positions.number_x,
                            this.positions.number_y-(measurement_number.actualBoundingBoxAscent/2),
                            this.positions.number_y-this.positions.name_y-(measurement_name.actualBoundingBoxAscent/2),
                            this.positions.max_arc,
                            this.font_name.largest_char
                        )
                    }
                }
                else{
                    this.font_name.drawText(
                        this.customisation.name,
                        this.positions.name_x,
                        this.positions.name_y
                    )
                    if(this.outline_name != null){
                        this.outline_name.drawText(
                            this.customisation.name,
                            this.positions.name_x,
                            this.positions.name_y
                        )
                    }
                }
            }
            if(this.font_number !== null && this.customisation.number !== ''){
                this.font_number.drawText(
                    this.customisation.number,
                    this.positions.number_x,
                    this.positions.number_y
                )
                if(this.outline_number != null){
                    this.outline_number.drawText(
                        this.customisation.number,
                        this.positions.number_x,
                        this.positions.number_y
                    )
                }
            }
            this.applyMask()
            if (typeof this.onRender === "function") {
                this.onRender()
            }
        }
    }
    return ProductCustomiser.construct(product_id,product_handle,html_id)
}